<script lang="ts" setup>
	const coreValues = [
		{
			img: '/v1727082986/HR_sytno7.webp',
			values: [
				{
					title: 'Ownership',
					description:
						'We believe in giving users control over their insurance. With us, users are not just policyholders; they’re empowered owners of their financial security.',
					icon: 'handshake'
				},
				{
					title: 'Integrity',
					description:
						'We hold ourselves to high ethical standards, ensuring transparency, honesty, and trust in all our interactions and decisions.',
					icon: 'integrity'
				}
			]
		},
		{
			img: '/v1727082970/olumide_radj2f.webp',
			values: [
				{
					title: 'Innovation',
					description:
						'We constantly strive to revolutionise the insurance experience with cutting-edge technology and forward-thinking solutions.',
					icon: 'idea'
				},
				{
					title: 'Customer-Centricity',
					description:
						'Customer needs and satisfaction are at the heart of everything we do, driving us to provide personalised and exceptional service.',
					icon: 'customer-service-2'
				}
			]
		}
	]
</script>

<template>
	<article class="flexed justify-center flex-col">
		<ui-title-header
			title="Our Core Values"
			:ui="{ size: 'md:text-[3.25em] text-[2em] leading-[38.4px] md:leading-[62.4px]' }"
		/>
		<ui-pad
			class="bg-yellow-100 md:min-h-[647px] md:rounded-[20px] mx-auto flex flex-wrap md:flex-col justify-between w-full mt-20 overflow-hidden"
			:ui="{ paddingBlock: 'md:py-0 pt-10 pb-0', paddingInline: '', width: 'max-w-[1240px]' }"
		>
			<div
				v-for="(core, index) in coreValues"
				:key="'core-' + index"
				class="flex justify-between group items-end w-full"
			>
				<div class="flex items-start gap-5 flex-wrap w-full justify-around px-5 md:px-10 py-8">
					<div
						v-for="(item, valIndex) in core.values"
						:key="'values-' + valIndex"
						class="flex-col justify-start items-center gap-6 inline-flex"
					>
						<div
							class="w-20 h-20 flexed justify-center bg-white rounded-full border border-gray-300 flex-none"
						>
							<tools-icon dir="random" :icon="item.icon" :height="40" :width="40" />
						</div>
						<div class="flex-col justify-start items-center gap-2.5 flex">
							<div class="flex-col justify-start items-center gap-2.5 flex">
								<div
									class="max-w-[294px] text-center text-gray-700 md:text-xl font-medium md:leading-loose"
								>
									{{ item.title }}
								</div>

								<div
									class="max-w-[324px] text-center text-gray-600 md:text-base font-normal md:leading-normal"
								>
									{{ item.description }}
								</div>
							</div>
						</div>
					</div>
				</div>

				<nuxt-img
					:src="core.img"
					alt="hr"
					loading="lazy"
					class="max-h-[310px] object-cover hidden md:inline self-stretch group-first:mt-0 mt-auto"
				/>
			</div>
		</ui-pad>
	</article>
</template>

<style></style>
